// extracted by mini-css-extract-plugin
export default {"FirstPage":"FirstPage_FirstPage__QEe5T"};